// third-party
import { FormattedMessage } from 'react-intl';

// assets
import { UserSquare } from 'iconsax-react';

// type
import { NavItemType } from 'types/menu';
// icons
const icons = {
  icon1: UserSquare
};
// ==============================|| MENU ITEMS - CHARTS & MAPS ||============================== //

const getAdminUsersMenu = (ncvetCompliance: boolean, isRootOrganization: boolean = true): NavItemType => ({
  id: 'group-users',
  type: 'group',
  icon: icons.icon1,
  name: 'Users',
  children: [
    {
      id: 'users',
      title: <FormattedMessage id="Users" />,
      type: 'collapse',
      icon: icons.icon1,
      children: [
        {
          id: 'Admin',
          title: <FormattedMessage id="Admin List" />,
          type: 'item',
          url: '/users/admin'
        },
        {
          id: 'faculty',
          title: <FormattedMessage id="Faculty List" />,
          type: 'item',
          url: '/users/faculty'
        },
        {
          id: 'Learner',
          title: <FormattedMessage id="Learner List" />,
          type: 'item',
          url: '/users/learner'
        },
        ...(ncvetCompliance && isRootOrganization
          ? [
              {
                id: 'AwardingBody',
                title: <FormattedMessage id="Awarding Body List" />,
                type: 'item',
                url: '/users/awardingBody'
              }
            ]
          : []),
        ...(ncvetCompliance && isRootOrganization
          ? [
              {
                id: 'Assessor',
                title: <FormattedMessage id="Assessor List" />,
                type: 'item',
                url: '/users/assessor'
              },
              {
                id: 'AssessorAgency',
                title: <FormattedMessage id="Assessor Agency" />,
                type: 'item',
                url: '/users/assessor-agency'
              }
            ]
          : [])
      ]
    }
  ]
});

const FacultyUsers: NavItemType = {
  id: 'group-users',
  type: 'group',
  icon: icons.icon1,
  name: 'Users',
  children: [
    {
      id: 'users',
      title: <FormattedMessage id="Users" />,
      type: 'collapse',
      icon: icons.icon1,
      // type: 'item',
      // url: '/users'
      children: [
        {
          id: 'Learner',
          title: <FormattedMessage id="Learner List" />,
          type: 'item',
          url: '/users/learner'
        }
      ]
    }
  ]
};

export default getAdminUsersMenu;
export { FacultyUsers };

// Awarding Body should only see/manage Assessors under Users.
export const getAwardingBodyUsersMenu = (): NavItemType => ({
  id: 'group-users',
  type: 'group',
  icon: icons.icon1,
  name: 'Users',
  children: [
    {
      id: 'users',
      title: <FormattedMessage id="Users" />,
      type: 'collapse',
      icon: icons.icon1,
      children: [
        {
          id: 'Assessor',
          title: <FormattedMessage id="Assessor List" />,
          type: 'item',
          url: '/users/assessor'
        },
        {
          id: 'AssessorAgency',
          title: <FormattedMessage id="Assessor Agency" />,
          type: 'item',
          url: '/users/assessor-agency'
        }
      ]
    }
  ]
});
